import React, { useState } from 'react';

import { Vragen } from './styled';
import { Veelgestelde } from '../../subpages';
import { Button, Typography, ReactIcon, Accordion, ImageCarousel } from '../../components';
import AndersModal from './AndersModal';

import contact1 from '../../assets/images/contact/contact1.jpg';

import { GeneralContext } from '../../App';

const images = [contact1, contact1, contact1];

export default function Contact(props) {
    const { hasPhone } = React.useContext(GeneralContext);

    const [ openModal, setOpenModal ] = useState(false);

    const onSubmit = (event) => {
        event.preventDefault()
    }
    
    return (
        <div>
            <Vragen>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: hasPhone && '90%' }}>
                    <Typography type='h1' style={{ color: '#032d34', margin: hasPhone ? '0 0 10vw 0' : '0 0 2vw 0' }}>Heb je nog vragen?</Typography>
                    <Typography style={{ margin: hasPhone ? '0 0 5vw 0' : '0 0 1vw 0', width: hasPhone && '90vw' }}>Zit jij nog met vragen, twijfels of wil je graag in gesprek {!hasPhone && <br/>}gaan met ons? Laat het dan weten!</Typography>
                    <Typography>Ik zoek contact als</Typography>
                    <div style={{ display: 'flex', gap: hasPhone ? '3vw' : '1vw', justifyContent: hasPhone && 'center', margin: hasPhone ? '3vw 0 10vw 0' : '0.5vw 0 2vw 0', flexWrap: 'wrap', width: hasPhone && '50vw'}}>
                        <Button text='Ouder' hashTo='/ouders#aanmelden' buttonstyle='fourthly' />
                        <Button text='Zorgprofessional' to='/zorgprofessionals' buttonstyle='fourthly' />
                        <Button text='Gemeente' to='/gemeente' buttonstyle='fourthly' />
                        <Button text='Anders' href='mailto:info@centeringfeeding.com' buttonstyle='fourthly' />
                    </div>
                    <div style={{ display: 'flex', gap: hasPhone ? '2vw' : '0.5vw', margin: hasPhone ? '0 0 7vw 0' : '0 0 1vw 0'}}>
                        <ReactIcon name='instagram' />
                        <ReactIcon name='linkedin' />
                        <ReactIcon name='youtube' />
                    </div>
                    <Accordion
                        headertext='Bedrijfsgegevens NOLIA BabyFeeding'
                        headercolor='#145f68'
                        align='center'
                    >
                        <Typography>
                            NOLIA BabyFeeding<br/>
                            AGB: 90116177<br/>
                            KvK: 75534487<br/>
                            Herenstraat 5<br/>
                            6021 GR Budel<br/>
                            <a href='mailto:info@babyfeeding.nl'>info@babyfeeding.nl</a><br/><br/>


                            Nadine Somers<br/>
                            Oprichtster NOLIA BabyFeeding, <br/>Lactatiekundige, verloskundige<br/>
                            IBCLC: 309803<br/>
                            NVL: 092022
                        </Typography>
                    </Accordion>
                </div>
                <ImageCarousel images={images} />
            </Vragen>
            {false && <Veelgestelde />}
            <AndersModal 
                open={openModal}
                onClose={() => setOpenModal(false)}
                onSubmit={onSubmit}
            />
        </div>
    );
}